import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { _getNodesBySiteAndFloor, _updateNode } from '../shared/httpservice/apis/nodes';
const createInitialState = () => ({
    loading: false,
    response: null,
    hasError: false,
    error: {},
});
const initialState = createInitialState();
const fetchNodesBySiteAndFloor = createAsyncThunk('nodes/fetchNodesBySiteAndFloor', async ({ siteId, floorId, pageSize = 100 }, { rejectWithValue }) => {
    try {
        // Fetch the first page
        const firstPageResponse = await _getNodesBySiteAndFloor(siteId, floorId, 0, pageSize);
        const { totalPages, content } = firstPageResponse;
        // Prepare requests for remaining pages
        const remainingPages = Array.from({ length: totalPages - 1 }, (_, i) => _getNodesBySiteAndFloor(siteId, floorId, i + 1, pageSize));
        const remainingPagesResponses = await Promise.all(remainingPages);
        // Combine all content arrays
        const allContent = [
            ...content,
            ...remainingPagesResponses.flatMap((response) => response.content),
        ];
        // Return a single response object with combined content
        return {
            ...firstPageResponse,
            content: allContent,
        };
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
const updateNode = createAsyncThunk('nodes/updateNode', async ({ siteId, nodeId, data }, { rejectWithValue }) => {
    try {
        const response = await _updateNode(siteId, nodeId, data);
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
const nodesSlice = createSlice({
    name: 'nodes',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNodesBySiteAndFloor.pending, (state) => {
            state.loading = true;
            state.hasError = false;
            state.error = {};
        })
            .addCase(fetchNodesBySiteAndFloor.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
            state.hasError = false;
        })
            .addCase(fetchNodesBySiteAndFloor.rejected, (state, action) => {
            state.loading = false;
            state.hasError = true;
            state.error = action.payload;
        })
            .addCase(updateNode.pending, (state) => {
            state.loading = true;
            state.hasError = false;
            state.error = {};
        })
            .addCase(updateNode.fulfilled, (state, action) => {
            state.loading = false;
            state.hasError = false;
            // Update the specific node in the response
            if (state.response && state.response.content) {
                const nodeIndex = state.response.content.findIndex((node) => node.nodeId === action.payload.nodeId);
                if (nodeIndex !== -1) {
                    state.response.content[nodeIndex] = { ...state.response.content[nodeIndex], ...action.payload };
                }
            }
        })
            .addCase(updateNode.rejected, (state, action) => {
            state.loading = false;
            state.hasError = true;
            state.error = action.payload;
        });
    },
});
export default nodesSlice.reducer;
export { fetchNodesBySiteAndFloor, updateNode };
